"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var AXSBlock_1 = __importDefault(require("../AXSBlock/AXSBlock"));
var Div = styled_components_1.default(AXSBlock_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-content: ", ";\n  align-items: ", ";\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n  text-align: left;\n"], ["\n  align-content: ",
    ";\n  align-items: ", ";\n  display: flex;\n  flex-direction: ",
    ";\n  flex-wrap: ", ";\n  justify-content: ",
    ";\n  text-align: left;\n"])), function (_a) {
    var alignContent = _a.alignContent;
    return alignContent ? alignContent : 'stretch';
}, function (_a) {
    var alignItems = _a.alignItems;
    return (alignItems ? alignItems : 'stretch');
}, function (_a) {
    var flexDirection = _a.flexDirection;
    return flexDirection ? flexDirection : 'row';
}, function (_a) {
    var flexWrap = _a.flexWrap;
    return (flexWrap ? flexWrap : 'nowrap');
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent ? justifyContent : 'flex-start';
});
var AXSFlex = function (props) {
    return (React.createElement(Div, __assign({}, props, { backgroundColor: props.backgroundColor, className: classnames_1.default(['c-axs-flex', props.className]) }), props.children));
};
AXSFlex.defaultProps = {
    backgroundColor: 'inherit',
    color: 'inherit',
};
exports.default = AXSFlex;
var templateObject_1;
//# sourceMappingURL=index.js.map